import DriversTable from "./DriversTable";

export default function Drivers() {
  return <DriversTable />;
}
